/**
 * 金额展示工具：统一“先量化到分，再展示”的规则。
 *
 * 背景：JS 浮点累加会产生 6737.969999999999 这类尾差。
 * 不同展示方式对尾差处理不一致——antd <Statistic precision> 对小数是“截断”（→ 6737.96），
 * 而 toLocaleString 是“四舍五入”（→ 6737.97），同一个底层值就显示出 1 分钱差。
 * 这里在求和与展示前统一量化到固定小数位，消除该不一致。
 */

const DEFAULT_FRACTION_DIGITS = 2;

/**
 * 将金额量化到指定小数位（默认 2 位，按四舍五入），消除二进制浮点尾差。
 * 非有限数（NaN/Infinity/null/undefined）归一为 0，避免把尾差扩散到展示层。
 */
export const roundMoney = (value, fractionDigits = DEFAULT_FRACTION_DIGITS) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
        return 0;
    }
    const factor = 10 ** fractionDigits;
    // +Number.EPSILON 修正二进制浮点表示误差，确保 6737.969999999999 → 6737.97
    return Math.round((numericValue + Number.EPSILON) * factor) / factor;
};

/**
 * 对一组金额求和并量化到指定小数位。求和过程会过滤非有限数。
 */
export const sumMoney = (values, fractionDigits = DEFAULT_FRACTION_DIGITS) => {
    const total = (Array.isArray(values) ? values : []).reduce((accumulated, value) => {
        const numericValue = Number(value);
        return accumulated + (Number.isFinite(numericValue) ? numericValue : 0);
    }, 0);
    return roundMoney(total, fractionDigits);
};
